import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import { withConfig } from 'src/withConfig';

interface MarketGroupPropsType {
    variant: DefaultComponentVariantType | null;
}

const setMarketGroup = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.medium};
        `;
    }
    return css``;
};


export const MarketGroup = withConfig(theme => styled('div', { label: 'MarketGroup' })<MarketGroupPropsType>`
    ${({ variant }): SerializedStyles => setMarketGroup(variant, theme)}
    font-size: ${theme.star.fontSize.small};
`);

interface MarketDisplayColumnType {
    columns?: string;
    variant: DefaultComponentVariantType | null;
}

const setSelectionRabList = (
    variant: DefaultComponentVariantType | null,
    theme: EmotionTheme,
    columns?: string
): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: ${columns === 'Column' ? 'flex' : 'flex'};
            flex-flow: ${columns === 'Column' ? 'column nowrap' : 'row nowrap'};
            gap: ${theme.star.gap.small};
            @media ${theme.star.mediaQuery.desktop} {
                flex-flow: row nowrap;
            }
        `;
    }
    return css`
        display: ${columns === 'Column' ? 'block' : 'flex'};
    `;
};

export const SelectionRabList = withConfig(theme => styled('ul', { label: 'SelectionRabList' })<MarketDisplayColumnType>`
    ${({ variant, columns }): SerializedStyles => setSelectionRabList(variant, theme, columns)}
    flex: 1 1 0;
    width: 100%;
`);

interface SelectionGroupWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const SelectionGroupWrapper = withConfig(theme => styled('div', { label: 'SelectionGroupWrapper' })<SelectionGroupWrapperPropsType>`
    border-left: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none' : `1px solid ${theme.star.eventRow.borderColor}`};
    display: flex;
    flex-flow: column nowrap;
`);

interface SelectionsGroupPropsType {
    variant: DefaultComponentVariantType | null;
}

export const SelectionsGroup = withConfig(theme => styled('div', { label: 'SelectionsGroup' })<SelectionsGroupPropsType>`
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    width: 100%;
    gap: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.gap.small : '0'};
`);

export const ChevronIconWrapper = styled(ChevronIcon, { label: 'ChevronIconWrapper' })`
    margin: 0 8px;
    width: 12px;
    flex: 0 0 12px;
    fill: currentcolor;
`;

export const ChevronIconMoreWrapper = styled(ChevronIconWrapper, { label: 'ChevronIconMoreWrapper' })`
    margin: 0 0 0 4px;
`;
